import { Injectable } from 'angular-ts-decorators';

import { Subject, Observable } from 'rxjs';

/**
 * Service that expose $location events as streams
 */
@Injectable('locationStreams')
export class LocationStreams {
  private changeSuccessSubject: Subject<any>;
  public changeSuccess$: Observable<any>;

  constructor($rootScope: ng.IRootScopeService) {
    'ngInject';

    this.changeSuccessSubject = new Subject();

    $rootScope.$on('$locationChangeSuccess', (event, next) => {
      this.changeSuccessSubject.next(next);
    });

    /**
     * stream that emits the current url (http://www.softwearconnect.lc/www.html#/profile)
     * every time on $locationChangeSuccess
     */
    this.changeSuccess$ = this.changeSuccessSubject.asObservable();
  }
}
